import React from "react";

export default function SQL_VIEW() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_VIEW</h1>
      <p>This is the SQL_VIEW component generated from the SQL JSON.</p>
    </div>
  );
}
